var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventMap } from './events';
import { AdapterMap } from './adapters';
import { createPromisePair } from './utils';
var Hive = /** @class */ (function () {
    function Hive() {
        /**
         * Indicates if Hive is completely ready to dispatch events
         */
        this.isReady = false;
        this.queue = [];
        var _a = createPromisePair(), promise = _a[0], resolve = _a[1];
        this.initPromisePair = {
            promise: promise,
            resolve: resolve
        };
        this.setupListeners();
    }
    /**
     * Hooks into all adapters with defined `onReady` hooks so we can automatically
     * flush the queue once all adapters are ready and Hive has been initialized.
     */
    Hive.prototype.setupListeners = function () {
        var _this = this;
        var readyPromises = [this.initPromisePair.promise];
        var _loop_1 = function (adapter) {
            var current = adapter;
            if (typeof current.onReady === 'function') {
                readyPromises.push(new Promise(function (resolve) {
                    current.onReady(function () { return resolve(); });
                }));
            }
        };
        for (var _i = 0, _a = Object.values(AdapterMap); _i < _a.length; _i++) {
            var adapter = _a[_i];
            _loop_1(adapter);
        }
        Promise.all(readyPromises).then(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isReady = true;
                        return [4 /*yield*/, this.flush()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Hive.prototype.flush = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, queuedFn;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.queue.length) return [3 /*break*/, 5];
                        _i = 0, _a = this.queue;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        queuedFn = _a[_i];
                        return [4 /*yield*/, queuedFn()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.queue = [];
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Hive.prototype.initialize = function (options) {
        if (!this.apolloClient && options.context.apolloClient) {
            this.apolloClient = options.context.apolloClient;
        }
        this.initPromisePair.resolve();
    };
    /**
     * Allows runtime adapter configuration
     */
    Hive.prototype.configure = function (adapter, config) {
        var instance = AdapterMap[adapter];
        if (!instance.configure) {
            console.warn("[Hive] Attempted to configure ('".concat(adapter, "') invalid adapter and/or adapter does not support configuration."));
            return;
        }
        instance.configure(config);
    };
    /**
     * Tracks an event which is dispatched to its associated platforms; ensures events and their inputs match the defined specifications.
     *
     * Waits until all platforms are ready to dispatch.
     */
    Hive.prototype.track = function (name, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var event, enhanced, _i, _a, entry, eventPlatform, adapter, finalPayload, e_1;
            var _this = this;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        event = EventMap[name];
                        if (!event) {
                            console.error("[Hive] Invalid event '".concat(name, "' specified."));
                            return [2 /*return*/];
                        }
                        if (!this.isReady) {
                            console.log("[Hive] Adapters not yet ready. Event '".concat(name, "' added to queue."));
                            this.queue.push(function () { return _this.track(name, payload); });
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ((_b = event.enhance) === null || _b === void 0 ? void 0 : _b.call(event, payload, {
                                apolloClient: this.apolloClient,
                                adapters: Object.fromEntries(Object.entries(AdapterMap).map(function (_a) {
                                    var key = _a[0], adapter = _a[1];
                                    return [
                                        key,
                                        'context' in adapter ? adapter.context : null
                                    ];
                                }))
                            }))];
                    case 2:
                        enhanced = _c.sent();
                        for (_i = 0, _a = event.platforms; _i < _a.length; _i++) {
                            entry = _a[_i];
                            eventPlatform = entry;
                            adapter = AdapterMap[eventPlatform.name];
                            if (!adapter) {
                                console.warn("[Hive] Attempted to dispatch to unsupported platform ('".concat(eventPlatform.name, "')."));
                                return [2 /*return*/, Promise.reject()];
                            }
                            finalPayload = eventPlatform.transform
                                ? eventPlatform.transform(__assign({ eventName: name }, payload), enhanced)
                                : adapter.transform(__assign({ eventName: eventPlatform.alias || name }, payload), enhanced);
                            adapter.track(finalPayload);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        console.error("[Hive] Error tracking event '".concat(name, "'"), e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Hive;
}());
export default new Hive();
